import { DismissableLayer as RadixDismissableLayer } from 'radix-ui/internal';
import type { ReactPortal } from 'react';
import { useCallback, useState } from 'react';
import { createPortal } from 'react-dom';
import { RemoveScroll } from 'react-remove-scroll';

export const useMenuPortalBranch = (): {
  menuPortalTarget: HTMLElement | undefined;
  menuPortalBranch: ReactPortal | null;
  onMenuOpen: () => void;
  onMenuClose: () => void;
} => {
  const [node, setNode] = useState<HTMLElement | null>(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const menuPortalBranch =
    typeof document !== 'undefined'
      ? createPortal(
          <RemoveScroll
            ref={setNode}
            enabled={isMenuOpen}
            forwardProps
            shards={node ? [node] : []}
            allowPinchZoom
          >
            <RadixDismissableLayer.Branch style={{ pointerEvents: 'auto' }} />
          </RemoveScroll>,
          document.body,
        )
      : null;

  return {
    menuPortalTarget: node ?? undefined,
    menuPortalBranch,
    onMenuOpen: useCallback(() => setIsMenuOpen(true), []),
    onMenuClose: useCallback(() => setIsMenuOpen(false), []),
  };
};
